import React from 'react'
import { parseLinksFooter as parseLinks, ExternalFooterLink } from './Links'

function Footer({ routes, lesserRoutes }) {
  const footerRoutes = [...routes, ...lesserRoutes]
  const companyLinks = parseLinks(footerRoutes, 'COMPANY')
  const mapLinks = parseLinks(footerRoutes, 'MAP')
  const locationLinks = parseLinks(footerRoutes, 'LOCATION')
  const communityLinks = parseLinks(footerRoutes, 'COMMUNITY')
  return (
    <footer>
      <div id={'footer-center'}>
        <div id={'footer-columns'}>
          <div className={'footer-column'}>
            <h4>{'Foamspace Corp'}</h4>
            {companyLinks}
            <ExternalFooterLink
              key="f-terms-of-service"
              href="/tos"
              text="Terms of Service"
            />
            <ExternalFooterLink
              key="f-privacy-policy"
              href="/privacy"
              text="Privacy Policy"
            />
          </div>
          {mapLinks.length !== 0 ? (
            <div className={'footer-column'}>
              <h4>{'Map'}</h4>
              {mapLinks}
            </div>
          ) : null}
          {locationLinks.length !== 0 ? (
            <div className={'footer-column'}>
              <h4>{'Location'}</h4>
              {locationLinks}
            </div>
          ) : null}
          {communityLinks.length !== 0 ? (
            <div className={'footer-column'}>
              <h4>{'Community'}</h4>
              {communityLinks}
            </div>
          ) : null}
          <div className={'footer-column'}>
            <h4>{'Contact'}</h4>
            <ExternalFooterLink
              key="f-contact"
              href="mailto:info@foam.space"
              text="info@foam.space"
            />
          </div>
          <div className={'footer-column'} style={{ 'flex-grow': 1 }}>
            <h4>Token Addresses</h4>
            <ExternalFooterLink
              key="f-token-mainnet"
              href="https://etherscan.io/token/0x4946fcea7c692606e8908002e55a582af44ac121"
              text="Mainnet: 0x4946Fcea7C692606e8908002e55A582af44AC121"
            />
            <ExternalFooterLink
              key="f-token-optimism"
              href="https://optimistic.etherscan.io/token/0x79e6c6b6aaba4432fabacb30cc0c879d8f3e598e"
              text="Optimism: 0x79E6c6b6aABA4432FAbacB30cC0C879D8f3E598e"
            />
            <ExternalFooterLink
              key="f-token-base"
              href="https://basescan.org/token/0x6059d0ed9368c36941514d2864fd114a84853d5a"
              text="Base: 0x6059d0ed9368c36941514d2864fD114a84853d5a"
            />
          </div>
        </div>
      </div>
      <div id={'footer-copyright'}>{'©2022 Foamspace Corp'}</div>
    </footer>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/Components/Footer.js